// Package imports:
import React from 'react'
// Component imports:
import Button from '../../../ui-elements/Button/Button';
import Icon from '../CustomIcon/CustomIcon';
// Service imports:
import { gtmPush } from '../../../services/utils';

const LoggedOut: React.FC = () => {
    return (
        <ul className="KCL_logged-out">
            <li>
                <a
                    href={`/Innskraning?ReturnUrl=${window.location.pathname}`}
                    onClick={() => gtmPush('buttonClick', 'innskraning', 'show_form')}
                >
                    <span className='icon-span' title='Innskrá'>
                        <Icon type="profile" />
                    </span>
                    <span className='text-span'>
                        Innskrá
                    </span>
                </a>
            </li>
            <li>
                <Button
                    anchorProps={{ href: "/Verdskra" }}
                    onClick={() => gtmPush('buttonClick', 'nyskra', 'show_form')}
                >
                    Nýskrá
                </Button>
            </li>
        </ul>
    );
}

export default LoggedOut;
